import { render } from "./ProjectPrognoz.vue?vue&type=template&id=e015b64e"
import script from "./ProjectPrognoz.vue?vue&type=script&lang=js"
export * from "./ProjectPrognoz.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__